
<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
			<vs-card>
			<div class="p-4 flex flex-col w-full">
				<h3>
					Direcciones
				</h3>
			</div>
			<div class="vx-row p-4 flex flex-col w-full">
				<div class="vx-col sm:w-3/4 w-full mb-2">
					<div class="search-results" style="width:100% !important;">
						<v-select placeholder="Listado de direcciones" v-model="selectDireccion" label="direccion" :options="listaDirecciones" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-on:input="computadaDireccion"/>
						<br>
					</div>
				</div>
				<div class="vx-col w-full ">
					<div class="search-results" style="width:100% !important;">
							<vs-button data-toggle="tooltip" data-placement="bottom" title="Agregar dirección" data-original-title="Agregar dirección" @click="habilitarDireccion" size="small" color="success" class="mt-3"><i class="material-icons" >add</i></vs-button>
					</div>
				</div>
			</div>
			<div class="vx-row p-4  w-full">
				<div class="vx-col sm:w-2/2 w-full mb-2">
					<vs-input :disabled="estado_direccion"
						v-validate="'required|min:3'"
						data-vv-validate-on="blur"
						label-placeholder="direccion"
						name="direccion"
						placeholder="Dirección*"
						v-model="direccion"
						class=" w-full  mt-6" />
						<span class="text-danger text-sm">{{ errors.first('direccion') }}</span>
				</div>
				<div class="vx-col sm:w-2/2 w-full mb-2">
					<vs-input :disabled="estado_referencia"
						data-vv-validate-on="blur"
						label-placeholder="referencia"
						name="referencia"
						placeholder="Referencia"
						v-model="referencia"
						class="  w-full mt-6" />
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_pais" placeholder="Seleccione un País*" label="descripcion" key="valor" :options="selects.paises" v-on:input="changePais" v-model="pais"></v-select>
					<span class="text-danger text-sm">{{ errors.first('pais') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_provincia"  placeholder="Seleccione un Provincia*" label="descripcion" key="valor" :options="selects.provincias" v-on:input="changeProvincia" v-model="provincia"></v-select>
					<span class="text-danger text-sm">{{ errors.first('provincia') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_canton"  placeholder="Seleccione un Cantón*" label="descripcion" key="valor" :options="selects.ciudades" v-on:input="changeCiudad" v-model="canton"></v-select>
					<span class="text-danger text-sm">{{ errors.first('canton') }}</span>
				</div>
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<v-select :disabled="estado_parroquia" placeholder="Seleccione un Parroquía*" label="descripcion" key="valor" :options="selects.barrios" v-model="parroquia"></v-select>
				</div>
				
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_telefono"
							data-vv-validate-on="blur"
							label-placeholder="telefono"
							name="telefono"
							placeholder="Telefono"
							v-model="telefono"
							class=" w-full mt-6" />
					<span class="text-danger text-sm"></span>
				</div>
				
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input :disabled="estado_celular"
							data-vv-validate-on="blur"
							label-placeholder="celular"
							name="celular"
							placeholder="Celular"
							v-model="celular"
							class=" w-full  mt-6" />
					<span class="text-danger text-sm"> </span>
				</div>
				<div class="vx-col sm:w-2/2 w-full mb-2">
					<vs-button class="float-right mt-6"  @click="insertarActualizar" :disabled="!validateForm">Guardar Dirección</vs-button>
				</div>
			</div>
			</vs-card>
      </vs-col>
	  <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
			<p>{{ mensaje }}
				<br>
			</p>
			<div class="flex flex-wrap text-center mb-3">
				<vs-button  color="primary"  @click="(popupMensaje = !popupMensaje)">Aceptar</vs-button>
			</div>
		</vs-popup>
    </vs-row>
</template>

<script>
export default {
    data() {
        return {
			listaDirecciones:[],
			estado_telefono:true,
			estado_celular:true,
			estado_direccion:true,
			estado_referencia:true,
			estado_pais:true,
			estado_provincia:true,
			estado_canton:true,
			estado_parroquia:true,
			pais:{descripcion:'Ecuador',valor:'1'},
			provincia:{descripcion:'Guayaquil',valor:'1'},
			canton:{descripcion:'',valor:''},
			parroquia:{descripcion:'',valor:''},
			telefono:'',
			celular:'',
			direccion:'',
			referencia:'',
			cod_persona:'',
			id_direccion:'',
			id_usuario:'',
			popupMensaje : false,
			mensaje : '',
			selectDireccion:null,
			form:{
				nombre:"",
				id_pais:"1",
				id_provincia:"1",
				id_ciudad:"",
				id_barrio:"",
			},
			states:{},
			selects:{
				paises: [],
				provincias:[],
				ciudades:[],
				barrios:[]
			},
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() &&
			this.direccion != '' &&
			(_.isEmpty(this.pais)== true ) ? false : (_.size(this.pais.descripcion) == 0 ) ? false : true &&     
			(_.isEmpty(this.provincia)== true ) ? false : (_.size(this.provincia.descripcion) == 0 ) ? false : true &&     
			(_.isEmpty(this.canton)== true ) ? false : (_.size(this.canton.descripcion) == 0 ) ? false : true &&    
			(_.isEmpty(this.parroquia)== true ) ? false : (_.size(this.parroquia.descripcion) == 0 ) ? false : true;
        },
    },
    methods: {
		computadaDireccion(){
			var direccion = (this.selectDireccion);
			if(_.isEmpty(direccion)){
				this.clearForm();
			}else{
				this.cargaDireccion(direccion);
			}    
			return '';
		},
		paisesRest(clean=true){
			if(clean)this.form.id_pais="";
			var q="paises";
			this.$vs.loading();
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/paises`)
			.then((response) => {
				this.$vs.loading.close(); 
				this.selects[q] = response.data.data;
				return this.changePais(clean);

			})
			.catch((error)=>{
				this.$vs.loading.close(); 
			});
		},
		provinciasRest(clean=true){
			if(clean)this.form.id_pais="";
			var q="provincias";
			if(_.size(this.pais.descripcion))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincias`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
						return this.changeProvincia(clean);
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
						
					});
		},
		ciudadesRest(clean=true){
			if(clean){
				this.form.id_ciudad="";
				this.form.id_barrio="";
			}
			var q="ciudades";
			if(_.size(this.pais.descripcion) && _.size(this.provincia.descripcion))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/cantones`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
						return this.changeCiudad(clean);
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
					});
		},
		barriosRest(clean=true){
			if(clean)this.form.id_barrio="";
			var q="barrios";
			if(_.size(this.pais.descripcion) && _.size(this.provincia.descripcion) && _.size(this.canton.descripcion))
			return this.$http.get(this.$store.state.domain+`mapgrafi/division-geografica/pais/${this.pais.valor}/provincia/${this.provincia.valor}/canton/${this.canton.valor}/parroquias`)
					.then((response) => {
						this.$vs.loading.close(); 
						this.selects[q] = response.data.data;
					})
					.catch((error)=>{
						this.$vs.loading.close(); 
					});
		},
		changePais(clean=true){
			if(_.isEmpty(this.pais)){
				this.provincia={descripcion:'',valor:''};
				this.canton={descripcion:'',valor:''};
				this.pais={descripcion:'',valor:''};
				this.parroquia={descripcion:'',valor:''};
				this.selects.provincias=[];
				this.selects.barrios=[];
				this.selects.ciudades=[];
			}else{
				return Promise.all([
					this.provinciasRest(clean)
				]).then((values)=>{
					// console.log("se cambio pais");
				});
			}
		},
		changeProvincia(clean=true){
			if(_.isEmpty(this.provincia)){
				this.provincia={descripcion:'',valor:''};
				this.canton={descripcion:'',valor:''};
				this.parroquia={descripcion:'',valor:''};
				this.selects.ciudades=[];
				this.selects.barrios=[];
			}else{
				return Promise.all([
				this.ciudadesRest(clean)
				]).then((values)=>{
					// console.log("se cambio la provincia");
				});
			}
		},
		changeCiudad(clean=true){
			if(_.isEmpty(this.canton)){
				this.canton={descripcion:'',valor:''};
            	this.parroquia={descripcion:'',valor:''};
				this.selects.barrios=[];
			}else{
				return Promise.all([
					this.barriosRest(clean)
				]).then((values)=>{
					// console.log("se cambio la ciudad");
				});
			}
		},
		habilitarDireccion(){
			var direccion = this.selectDireccion;
			if(_.isEmpty(direccion)){
				this.clearForm();
				this.desBlockInput();
			}else{
				this.clearForm();
			}    
		},

        validatorOnline(){
            if(!this.$store.state.AppActiveUser.status)
            this.$router.push('/');
			else{
				this.cargaGeneral();
			}
        },
		cargaDireccion(direccion){
			this.desBlockInput();
			this.pais={descripcion:'',valor:''};
			this.provincia={descripcion:'',valor:''};
			this.canton={descripcion:'',valor:''};
			this.parroquia={descripcion:'',valor:''};
			
			this.telefono              = direccion.telefono;
			this.celular               = direccion.celular;
			this.direccion             = direccion.direccion;
			this.referencia            = direccion.referencia;
			this.id_direccion          = direccion.id_direccion;
			this.pais.descripcion      = direccion.pais;
			this.provincia.descripcion = direccion.provincia;
			this.canton.descripcion    = direccion.canton;
			this.parroquia.descripcion = direccion.parroquia;
			this.cod_persona		   = direccion.cod_persona;
			this.pais.valor	           = direccion.id_pais;
			this.provincia.valor	   = direccion.id_provincia;
			this.canton.valor	       = direccion.id_canton;
			this.parroquia.valor	   = direccion.id_parroquia;
			this.changePais(false);
		},
		blockInput(){
			this.estado_telefono=true;
			this.estado_celular=true;
			this.estado_direccion=true;
			this.estado_referencia=true;
			this.estado_pais=true;
			this.estado_provincia=true;
			this.estado_canton=true;
			this.estado_parroquia=true;
		},
		desBlockInput(){
			this.estado_telefono=false;
			this.estado_celular=false;
			this.estado_direccion=false;
			this.estado_referencia=false;
			this.estado_pais=false;
			this.estado_provincia=false;
			this.estado_canton=false;
			this.estado_parroquia=false;
		},
		clearForm(){
			this.blockInput();
			this.selectDireccion=null;
			this.id_direccion='';
			this.telefono='';
			this.celular='';
			this.direccion='';
			this.referencia='';
			this.pais={descripcion:'',valor:''};
			this.provincia={descripcion:'',valor:''};
			this.canton={descripcion:'',valor:''};
			this.parroquia={descripcion:'',valor:''};
			this.cod_persona='';
			this.selects.provincias=[];
			this.selects.ciudades=[];
			this.selects.barrios=[];
		},
		cargaGeneral(){
		    this.$vs.loading();
			this.clearForm();
			this.id_usuario = this.$store.state.AppActiveUser.id_usuario;
			this.$http.post(this.$store.state.domain+`mapgrafi/direccion/direccion-carga-general`,{
				id_usuario				   :  this.$store.state.AppActiveUser.id_usuario, // id_usuario
				estado					   : 'A',
				cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
			})
			.then((response) => { 
			this.$vs.loading.close(); 
			if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
				else if (response.data.existeError) throw response.data.mensaje;
				else{
					this.listaDirecciones = response.data.data;
				}  
			})
			.catch(error=>{
				this.$vs.loading.close(); 
				this.popupMensaje = true;
				this.mensaje = error;
			})
		},
		insertarActualizar(){
			 var direccion = this.selectDireccion;
			 this.$vs.loading();
			 this.$http.post(this.$store.state.domain+`mapgrafi/direccion/direccion-insertar-actualizar`,{
				evento					   : (direccion == null) ? 'I' : 'U',
				id_usuario				   : this.id_usuario,
				id_direccion			   : this.id_direccion, 
             	telefono                   : this.telefono,
				celular                    : this.celular,
				direccion                  : this.direccion,
				referencia                 : this.referencia,
				pais                       : this.pais.descripcion,
				provincia                  : this.provincia.descripcion,
				canton                     : this.canton.descripcion,
				parroquia                  : this.parroquia.descripcion,
				id_pais                    : this.pais.valor,
				id_provincia               : this.provincia.valor,
				id_canton                  : this.canton.valor,
				id_parroquia               : this.parroquia.valor,
				estado					   : 'A',
				cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
          })
          .then((response) => { 
			this.$vs.loading.close(); 
            if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
              else if (response.data.existeError) throw response.data.mensaje;
                else{
					this.validatorOnline();
					this.popupMensaje = true;
					this.mensaje = response.data.mensaje;
                }  
		  })
		.catch(error=>{
			this.$vs.loading.close(); 
			this.popupMensaje = true;
			this.mensaje = error;
			
		})
		}
	},
    created(){
		this.validatorOnline();
			return Promise.all([ this.paisesRest(false)])
			.then((values)=>{
				// console.log("cargado inicial")
			})
    }
}
</script>
